export const sansSerifFontFamily = 'Lato, sans-serif'
export const serifFontFamily = 'Playfair Display, serif'

export type ForegroundStyle = 'light' | 'dark'

export const FLUID_CONTAINER_STYLE = {
  overflowY: 'auto',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  scrollSnapType: 'y mandatory',
}

export const pulseAnimation = {
  '0%': {
    transform: 'scale(0.96)',
  },
  '17%': {
    transform: 'scale(1)',
  },
  '33%': {
    transform: 'scale(0.96)',
  },
  '50%': {
    transform: 'scale(1)',
  },
  '66%': {
    transform: 'scale(0.96)',
  },
  '83%': {
    transform: 'scale(1)',
  },
  '100%': {
    transform: 'scale(0.96)',
  },
}
